<template>
  <div class="">
    <div class="text-center footer">
      <a class="footcopy" href="https://pointblanksoftware.com">&copy; 2019 Point Blank Software, LLC</a>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
.footer {
  padding-top: 20px;
}
.footcopy{
  color:#FFFFFF!important;
}
</style>
